import "./_module.scss";

import {ReactElement} from "react";

import {actualite} from "@/types/actualite";

import {Actualite} from "../Actualite/Actualite";
import {ActualiteSkeleton} from "../Actualite/Actualite";
import Section from "../Section/Section";

function ModuleActualite({
  actualites,
}: {
  actualites?: actualite[];
}): ReactElement {
  if (actualites !== undefined) {
    const AllActualite: ReactElement[] | undefined = actualites?.map(
      (article: actualite, index) => {
        return <Actualite article={article} key={`${index} ${article.id}`} />;
      },
    );
    return (
      <Section id="actualite">
        {AllActualite ? (
          AllActualite
        ) : (
          <div>
            <p>aucune actualité</p>
          </div>
        )}
      </Section>
    );
  } else {
    return (
      <Section id="actualite">
        <ActualiteSkeleton />
        <ActualiteSkeleton />
        <ActualiteSkeleton />
        <ActualiteSkeleton />
        <ActualiteSkeleton />
        <ActualiteSkeleton />
      </Section>
    );
  }
}

export default ModuleActualite;
